<section class="contact-top">
    
        
    <div class="inner_sec">
               
              <div class="container">    
                <h2>Painting Equipments.</h2>
              </div>  

            <div class="tabbing_sec">

            <div class="product_list"> 
                
                <div class="product_box">
                    <div class="container">

                      <div class="row">  
                        <div class="col-sm-3" *ngFor="let data of advanceMoullding">
                            <div class="productItem">
                                <figure> <img class="about-img" [src]="data.img" alt=""> </figure>
                                <h4>{{data.title}}</h4>
                            </div>
                        </div>
                     </div>  

                    </div>
                </div>

            </div>
            </div>
    </div>
       
        
    
</section>
